module.exports = __webpack_public_path__ + "img/tk-bg.932e5fef.png";